export enum RecordingStatuses {
    Starting = "starting",
    Started = "started",
    FailedToStart = "failedToStart",
    Stopped = "stopped",
    Ended = "ended",
    InProgress = "inProgress"
}
